import React, { Fragment} from "react";
import PropTypes from "prop-types";
import { Row, Col, CardTitle } from "reactstrap";
import i18n from "../../../../i18n";

const Instructions = ({ step }) => {

  return (
    <Fragment>
      <Row className="pb-2 text-center">
        <Col xxl={12} md={12} xs={12} className="text-start">
          <CardTitle className="h4">{i18n.t("Instructions")}</CardTitle>
        </Col>
        <Col xxl={`${6}`} md={`${6}`} xs={6}>
          <h6 className={`instructions-step active`}>{i18n.t("Step1")}</h6>
          <h6>{i18n.t("AssignPlate")}</h6>
          <i className="bx bx-down-arrow-circle fs-25 instructions-icon" />
        </Col>
        <Col xxl={`${6}`} md={`${6}`} xs={6}>
          <h6 className={`instructions-step ${step == 2 ? "" : "opacity-50"}`}>{i18n.t("Step2")}</h6>
          <h6>{i18n.t("Summary")}</h6>
          <i className={`bx bx-down-arrow-circle fs-25 instructions-icon ${step == 2 ? "" : "opacity-50"}`} />
        </Col>
      </Row>
    </Fragment>
  )
}

Instructions.propTypes = {
  step: PropTypes.number
}

export default Instructions;
